<template>
  <Transition name="fade">
    <div v-if="open" class="blur" @click="close"></div>
  </Transition>
  <Transition name="fade">
    <div v-if="open" class="modal" :class="classes">
      <IconButton
        :theme="closeButtonTheme"
        icon="cross"
        class="close-btn"
        @click="close"
      />
      <div v-if="hasImages" class="modal__images">
        <Media :images="images" cover cover-position="top center" />
      </div>
      <div class="modal__content">
        <div class="modal__content-inner">
          <slot />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import Media from "@/components/Media.vue";
import IconButton from "@/components/IconButton.vue";
import isEmpty from "lodash-es/isEmpty";

export default {
  name: "Modal",
  components: {
    Media,
    IconButton,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Object,
      default: () => ({}),
    },
    /** Solid white form column + dark close (e.g. sign-up modal). */
    lightFormColumn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  computed: {
    classes() {
      return {
        "modal--no-images": !this.hasImages,
        "modal--light-form": this.lightFormColumn,
      };
    },
    closeButtonTheme() {
      return this.lightFormColumn ? "secondary" : "white";
    },
    hasImages() {
      return !isEmpty(this.images);
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  background: $color-white;
  position: fixed;
  z-index: 1001;
  max-width: 1014px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  @include respond-above(md) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    transform: translateX(-50%) translateY(-50%);
    height: auto;
    left: 50%;
    top: 50%;
    right: auto;
    bottom: auto;
  }

  &__content,
  &__images {
    height: 50vh;
    overflow: hidden;

    @include respond-above(md) {
      height: auto;
      flex: 0 0 50%;
    }
  }

  &__images {
    overflow: hidden;

    :deep(.wrapper) {
      height: 100%;
    }
  }

  &__content {
    overflow-y: auto;
  }

  :deep(.button.close-btn.button--secondary) {
    cursor: pointer;
  }

  .close-btn {
    position: absolute;
    padding: 10px;
    border-radius: 50%;
    top: 8px;
    right: 8px;
    z-index: 1;

    @include respond-above(md) {
      top: 20px;
      right: 20px;
    }
  }

  &--no-images {
    display: block;

    @include respond-above(md) {
      display: block;
      max-width: 600px;
      width: 90%;
    }

    .modal__content {
      @include respond-above(md) {
        height: auto;
        flex: none;
      }
    }
  }

  &--light-form {
    .modal__content {
      background-color: $color-white;
    }
  }
}

.modal__content {
  position: relative;

  &-inner {
    text-align: center;
    @extend .containerV2;
    padding-top: 40px;
    padding-bottom: 40px;
    overflow: auto;

    @include respond-above(md) {
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.blur {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
